import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { formatAmount } from "../../../utility/CommonFunctions";
import moment from "moment";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import Logs from "../../Logs/Logs";

export default function BudgetLogs() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [budgetLogsData, setBudgetLogsData] = useState([]);

  useEffect(() => {
    GetBudgetLogs();
  }, []);

  const GetBudgetLogs = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_site_budget_request_detail + `budgetRequestId=${id}`;
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setBudgetLogsData(response?.data?.logs);
      }
    });
  };

  return (
    <>
      <>
        {isLoading && <BgBlurLoader />}
        <div className="content">
          <div className="content-head mb-5 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button
                role="button"
                className="btn back-arrow"
                onClick={() => navigate(-1)}
              >
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">Budget Logs</h1>
            </div>
          </div>
          <div className="card p-1">
            {budgetLogsData && budgetLogsData?.length > 0 ? (
              budgetLogsData?.map((item, index) => (
                <div
                  key={index}
                  className="accordion"
                  id={`accordionExample${index}`}
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${index === 0 ? "" : "collapsed"
                          }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${index}`}
                        aria-expanded={index === 0 ? "true" : "false"}
                        aria-controls={`collapse-${index}`}
                      >
                        <span className="bg-light rounded-5 py-4 px-5 fs-4">
                          {item?.expensehead?.name}
                        </span>
                      </button>
                    </h2>
                    <div
                      id={`collapse-${index}`}
                      className={`accordion-collapse collapse ${index === 0 ? "show" : ""
                        }`}
                      data-bs-parent={`#accordionExample${index}`}
                    >
                      <div className="accordion-body">
                        {item?.data?.length > 0 ? (
                          <ul className="list-group">
                            {item?.data?.map((item2, index2) => (
                              <li
                                key={index2}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                <div className="p-2">
                                  <span className="fw-bold">
                                    {formatAmount(item2?.amount)}
                                  </span>{" "}
                                  <span
                                    className={`badge ${item2?.status === 1
                                      ? "bg-success"
                                      : "bg-danger"
                                      } ms-2`}
                                  >
                                    {item2?.status === 1
                                      ? "Approved"
                                      : "Rejected"}
                                  </span>
                                </div>
                                <span className="text-muted fs-5">
                                  {moment(item2.updatedAt).format(
                                    "DD-MMM-YYYY hh:mm A"
                                  )}
                                </span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-muted text-center">
                            No records available
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="d-flex justify-content-center fw-medium text-muted py-5">
                {!isLoading && "No Logs Found"}
              </div>
            )}
          </div>
        </div>
      </>
    </>
  );
}
